import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private http: HttpClient) {}

  fetAvaibleMonth(): Observable<any> {
    return this.http.get<any>(`${environment.url}/apiTimesheet/available-month`);
  }

    getAvailableYears(): Observable<number[]> {
    return this.http.get<number[]>(
      `${environment.url}/apiLeave/available-years`
    );
  }
}
